import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {AccountModel} from "../../models/account.model";

require('./demand-account-table-row.scss');
@Component({
  standalone: false,
  selector: 'app-demand-account-table-row',
  templateUrl: './demand-account-table-row.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemandAccountTableRowComponent {

  @Input() account: AccountModel;
  @Output() selectAccount = new EventEmitter<AccountModel>();

  onSelectAccount(account: AccountModel) {
    this.selectAccount.emit(account);
  }

}
